import { QuestionCheckBox } from "@Components/Diagnostic/Question/QuestionCheckBox"
import { QuestionCheckBoxRadio } from "@Components/Diagnostic/Question/QuestionCheckBoxRadio"
import { QuestionSimple } from "@Components/Diagnostic/Question/QuestionSimples"
import { QuestionWithCard } from "@Components/Diagnostic/Question/QuestionWithCard"
import { QuestionWithMedia } from "@Components/Diagnostic/Question/QuestionWithMedia"
import { QuestionWithScale } from "@Components/Diagnostic/Question/QuestionWithScale"
import { QuestionYesOrNo } from "@Components/Diagnostic/Question/QuestionYesOrNo"
import { baseColors } from "@Constants/baseStyles"
import { SALUTANCE } from "@Services/AxiosInstance"

const getQuestionWidget = (args) => {
    const {
        question,
        isChildren,
        axisId,
        currentQuestionIndex,
        fetchingResponseByAxeId,
        responseByAxeId,
        hasDEInProgress,
        isParent
    } = args
    const hasResponse = responseByAxeId?.length > 0 && !fetchingResponseByAxeId
    const userResponse = SALUTANCE
        ? responseByAxeId?.find((response) => response?.surveyId === question?.id)
        : responseByAxeId[currentQuestionIndex]
    const questionWidget = question?.widget?.name?.toLowerCase()

    switch (questionWidget) {
        case "slider":
            return (
                <QuestionWithScale
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    questionNumber={currentQuestionIndex + 1}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    hasResponse={hasResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    precisionText={question?.precision}
                />
            )
        case "radio":
            return (
                <QuestionYesOrNo
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    questionNumber={currentQuestionIndex + 1}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    hasResponse={hasResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    precisionText={question?.precision}
                    conditionToSkip={question?.conditionToSkip}
                    indexToSkip={question?.indexToSkip}
                />
            )

        case "checkboxradio":
            return (
                <QuestionCheckBoxRadio
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    questionNumber={currentQuestionIndex + 1}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    hasResponse={hasResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    checkBoxItems={question?.proposalAnswerSurveys ?? []}
                    precisionText={question?.precision}
                    conditionToSkip={question?.conditionToSkip}
                    indexToSkip={question?.indexToSkip}
                />
            )
        case "file":
            return (
                <QuestionWithMedia
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    questionNumber={currentQuestionIndex + 1}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    proposalAnswer={question?.proposalAnswerSurveys}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                />
            )

        case "card":
            return (
                <QuestionWithCard
                    isFirstQuestion={+currentQuestionIndex === 0}
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    precisionText={question?.precision}
                    isChildren={isChildren}
                    key={question?.id}
                    questionNumber={currentQuestionIndex + 1}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    proposalAnswer={question?.proposalAnswerSurveys}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    parentLabel={question?.parent?.text}
                />
            )
        case "checkbox":
            return (
                <QuestionCheckBox
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    questionNumber={currentQuestionIndex + 1}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    hasResponse={hasResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    checkBoxItems={question?.proposalAnswerSurveys ?? []}
                    precisionText={question?.precision}
                    conditionToSkip={question?.conditionToSkip}
                    indexToSkip={question?.indexToSkip}
                />
            )
        default:
            return (
                <QuestionSimple
                    axisId={axisId}
                    surveyId={question?.id}
                    responseTypeId={question?.responseType?.id}
                    hasPrecision={question?.hasPrecision}
                    isChildren={isChildren}
                    key={question?.id}
                    questionNumber={currentQuestionIndex + 1}
                    color={baseColors.orange.primary}
                    question={question?.text}
                    responseIndex={currentQuestionIndex}
                    loading={fetchingResponseByAxeId}
                    userResponse={userResponse}
                    disabled={hasDEInProgress ?? false}
                    isParent={isParent}
                    precisionText={question?.precision}
                />
            )
    }
}

const gotoSurvery = ({ axis, bgColor, forVideoPoint = false, axeIndex }) => {
    navigation.navigate("Survey", {
        axisId: axis.id,
        axisName: axis.name,
        bgColor,
        allAxis: diagnosis,
        forVideoPoint,
        axeIndex
    })
}

export { getQuestionWidget, gotoSurvery }
